import styled from '@emotion/styled';
import { Button } from 'UI';

export const Container = styled(Button)`
  @media (max-width: 768px) {
    display: none;
  }
`;
